/*globals $:false*/

import ClipboardP from './presenter/recordm.clipboard.js';
import InstanceM from './model/recordm.model.entity.instance.js';
import InstanceP from './presenter/recordm.presenter.instance.js';

import tmpl from './templates/instance-container.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

/**
 * args:
 * * `core`: cob.app
 * * `opts`: accepts:
 *       * `container`: an element that should contain the UI
 *       * `exit`: a callback called when the user has asked to exit the Instance creation
 *       * `afterSave`: a callback called after saving the instance
 *       * `exitLabel`: a localize key to be used on the exit (back) button
 */
var InstanceCreate = function(core, opts) {

    var _$mainContainer,
        _clipboardP,
        _instanceP;

    var _urlData,
        _definitionId,
        _instanceM;

   const _opts = {...opts};

    var _loadingKey = core.getLoadingKey();

    var _getEmptyInstance = function(definitionId, loadLatch) {

        core.showLoading(_loadingKey, "_getEmptyInstance");

        InstanceM.getNewInstance(core, definitionId, true,
            function(instanceM) {
                _instanceM = instanceM;

                core.publish("modules:stack-description-updated");
                loadLatch.countDown("instance:new:empty");

                core.hideLoading(_loadingKey, "_getEmptyInstance");
            }
        );
    };

    var _start = function(definitionId, urlData) {
        //pause and init uses this function
        _definitionId = definitionId || _definitionId;
        _urlData = urlData || _urlData;

        // Creating a latch because the code becomes more
        // simple to read. This will happen after the domain has been loaded
        // successfully.
        var loadLatch = new utils.CountdownLatch(1, function() {

            core.showLoading(_loadingKey, "_loadLatch");

            _$mainContainer = $(tmpl({
                containerClass: "js-instance-create-container"
            }));

            core.translate("recordm.instances", _$mainContainer);

            if(_opts.container){
               _$mainContainer.appendTo(_opts.container);
            } else {
               _$mainContainer.appendTo('#'+core.getAppInstanceId());
            }
            _$mainContainer.removeClass("hidden");

            _clipboardP = new ClipboardP(core);
            _clipboardP.init(urlData);

            const _callbacks = {
                cancel: function() {
                    if (typeof _opts.exit == 'function') _opts.exit();
                    else core.navigateBack();
                },
                afterSave: function() {
                    if (typeof _opts.afterSave == 'function') _opts.afterSave();
                    else core.navigateBack();
                }
            };

            if (typeof _opts.afterSaveEdit == 'function') {
                _callbacks.afterSaveEdit = _opts.afterSaveEdit;
            }
            if (typeof _opts.afterSaveCreateNew == 'function') {
                _callbacks.afterSaveCreateNew = _opts.afterSaveCreateNew;
            }

            _instanceP = new InstanceP(core, _$mainContainer, _instanceM, _clipboardP, _callbacks, {
               params: { waitFor: true },
               exitLabel: _opts.exitLabel
            });
            _instanceP.init(false, true);

            core.hideLoading(_loadingKey, "_loadLatch.done");
        });

        _getEmptyInstance(_definitionId, loadLatch);

    };

    var _stop = function() {
        if (_instanceP) {
            _instanceP.destroy();
            _$mainContainer.remove();
        }
    };

    return {
        init: _start,
        pause: _stop,
        resume: _start,
        destroy: _stop,

        getDescription: function() {
            if (_instanceM) {
                return {
                    definition: {
                        id: _instanceM.data.jsonDefinition.id,
                        name: _instanceM.data.jsonDefinition.name,
                        description: _instanceM.data.jsonDefinition.description
                    }
                }
            } else {
                return {
                    definition: {
                        id: _definitionId
                    }
                };
            }
        }
    };
};

export default InstanceCreate;
